import GameNavigation from "../components/navigator"
import { Pay } from "../components/pay"

export const PayScreen = () => {
    return (
        <>
            <GameNavigation />
            <Pay />
        </>
    )
}